// Axios
import Axios from "./axios"

export const findEncryptedEmail = (body) => {
    return new Promise((resolve, reject) => {
        const data = Axios.post(`/user/sendEmailVerification`, body)
        resolve(data)
    })
}